import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { JOVE_CMS_USER_INFO_CACHE_KEY, JOVE_UNIVERSAL_AUTH_SESSION_KEY, joveMasterAdminEmailList, joveMasterAdminEmailListWithHaoTeam, joveOnlyBossMasterAdminEmailList } from '../constants';
import { OrganizationRoles } from '../shared/generated';
import { clearJoveAuthSsoCookie } from './joveAuthSession';
var AUTH0_SPA_CACHE_KEY_PREFIX = '@@auth0spajs@@';
/** Storage keys removed on logout; also interpolated into the pre-hydration inline script of every app's /auth/logout-sync page */

export var JOVE_AUTH_STORAGE_KEYS = [JOVE_CMS_USER_INFO_CACHE_KEY, JOVE_UNIVERSAL_AUTH_SESSION_KEY, 'jove-cms-token', 'WEBSITE_HAVE_SELECT_PORTAL'];
var JOVE_APP_LOGOUT_SYNC_PATH = '/auth/logout-sync';
var JOVE_APP_LOGOUT_SYNC_TIMEOUT = 5000;

var removeStorageKeys = function removeStorageKeys(storage) {
  JOVE_AUTH_STORAGE_KEYS.forEach(function (key) {
    return storage.removeItem(key);
  });
  Object.keys(storage).forEach(function (key) {
    if (key.startsWith(AUTH0_SPA_CACHE_KEY_PREFIX)) {
      storage.removeItem(key);
    }
  });
};

export var removeAllAuthKeys = function removeAllAuthKeys() {
  if (false) {
    return;
  }

  removeStorageKeys(window.sessionStorage);
  removeStorageKeys(window.localStorage); // also kill the cross-app SSO cookie so a signed-out session cannot be silently rehydrated by a sibling app

  clearJoveAuthSsoCookie();
};

var getOrigin = function getOrigin(url) {
  if (!url) {
    return undefined;
  }

  try {
    return new URL(url).origin;
  } catch (_) {
    return undefined;
  }
};

var getSiblingAppOrigins = function getSiblingAppOrigins() {
  if (false) {
    return [];
  }

  var _window$location = window.location,
      hostname = _window$location.hostname,
      protocol = _window$location.protocol;
  var labels = hostname.split('.');

  var _labels = _toArray(labels),
      appName = _labels[0],
      restLabels = _labels.slice(1);

  var siblingOrigins = [];

  if (['cms', 'dashboard'].includes(appName) && restLabels.length) {
    siblingOrigins.push("".concat(protocol, "//cms.").concat(restLabels.join('.')));
    siblingOrigins.push("".concat(protocol, "//dashboard.").concat(restLabels.join('.')));
    siblingOrigins.push("".concat(protocol, "//").concat(restLabels.join('.')));
  }

  return siblingOrigins;
};

var getJoveAppLogoutSyncOrigins = function getJoveAppLogoutSyncOrigins() {
  if (false) {
    return [];
  }

  return Array.from(new Set([process.env['NX_CMS_URL'], process.env['NX_DASHBOARD_URL'], process.env['NX_WEBSITE_URL']].map(getOrigin).concat(getSiblingAppOrigins()).filter(function (origin) {
    return origin && origin !== window.location.origin;
  })));
};

var syncLogoutWithOrigin = function syncLogoutWithOrigin(origin) {
  return new Promise(function (resolve) {
    if (false || !document.body) {
      resolve();
      return;
    }

    var iframe = document.createElement('iframe');
    var timer = window.setTimeout(cleanup, JOVE_APP_LOGOUT_SYNC_TIMEOUT);

    function cleanup() {
      window.clearTimeout(timer);
      window.removeEventListener('message', handleMessage);
      iframe.remove();
      resolve();
    }

    function handleMessage(event) {
      if (event.origin === origin && event.data === 'jove-auth-logout-sync-done') {
        cleanup();
      }
    }

    window.addEventListener('message', handleMessage);
    iframe.style.display = 'none';
    iframe.src = "".concat(origin).concat(JOVE_APP_LOGOUT_SYNC_PATH, "?t=").concat(Date.now());
    document.body.appendChild(iframe);
  });
};

export var removeAllJoveAppAuthKeys = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            removeAllAuthKeys();
            _context.next = 3;
            return Promise.all(getJoveAppLogoutSyncOrigins().map(syncLogoutWithOrigin));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function removeAllJoveAppAuthKeys() {
    return _ref.apply(this, arguments);
  };
}();
export var judgeIsJoveMasterAdmin = function judgeIsJoveMasterAdmin(userInfo) {
  var _ref2 = userInfo || {},
      email = _ref2.email;

  return joveMasterAdminEmailList.includes(email);
};
export var judgeIsJoveMasterAdminWithHaoTeam = function judgeIsJoveMasterAdminWithHaoTeam(userInfo) {
  var _ref3 = userInfo || {},
      email = _ref3.email;

  return joveMasterAdminEmailListWithHaoTeam.includes(email);
};
export var judgeIsJoveSalesAdmin = function judgeIsJoveSalesAdmin(userInfo) {
  var _ref4 = userInfo || {},
      userRoles = _ref4.userRoles;

  return !!(userRoles !== null && userRoles !== void 0 && userRoles.find(function (key) {
    return [OrganizationRoles.JOVE_ADMIN].includes(key);
  })) && !(userRoles !== null && userRoles !== void 0 && userRoles.find(function (key) {
    return ['ga-admin'].includes(key);
  })) && !judgeIsJoveMasterAdmin(userInfo);
};
export var judgeIsOnlyBossMasterAdmin = function judgeIsOnlyBossMasterAdmin(userInfo) {
  var _ref5 = userInfo || {},
      email = _ref5.email;

  return joveOnlyBossMasterAdminEmailList.includes(email);
};